module.exports = __webpack_public_path__ + "static/media/Trubbish_gaussian2.0ab82d15.png";